import { RecallPart } from "./recall-part";

export interface RecallHistory {
    id: string;
    localFsaDescLocal: string;
    govtRecallNumber: string;
    repairDate: string;
    repairDealerCode: string;
    fsaType: string;
    parts:  RecallPart[];
    recallTime: string;
    recallOnSameDay: string[];
    vin: string;
    dealerTradeName: string;
    lastPrintDate: string;
    launchDate: string;
    dealerAddress: string;
}
